import { render, staticRenderFns } from "./CustomerWholesaleToggle.vue?vue&type=template&id=32423eb6&scoped=true&"
import script from "./CustomerWholesaleToggle.vue?vue&type=script&lang=js&"
export * from "./CustomerWholesaleToggle.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWholesaleToggle.vue?vue&type=style&index=0&id=32423eb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32423eb6",
  null
  
)

export default component.exports